export default __webpack_public_path__ + "static/media/schedulemeetingarrow.f8a31c7e.svg";